import { useContext } from 'react'

import { AppConfigContext } from '../context/ConfigProvider'


const useAppConfig = () => {
    const { config } = useContext(AppConfigContext)

    if (!config) {
        throw new Error('Tv config not found')
    }

    return {
        config,
    }
}

export {
    useAppConfig,
}
